export default __webpack_public_path__ + "static/media/pic-man-1.2db6d1e6.png";